<template>
  <header class="app-header p-4 bg-blue-9">
    <router-link to="/" class="block mb-3 color-white">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.1 85.7">
        <path
          id="logo-p"
          class="logo-letter"
          d="M33.8 55.8c-1.1 7.1-1.9 12.4-2 12.9-1.1 7.7-7.2 14.7-19.2 16.7-.4.1-.8-.4-.5-.8 1.1-1.7 3-3.6 4.9-9.5 2.1-6.6 3.4-15.5 6.9-40.7.5-3.4 2.2-12.1 12-15.7 1.2-.4 2.1-.8 3.1-1 .4-.1.8.1.7.5-1.1 6.3-3.2 19.9-5.1 31.9 0 0 4.9-1.2 7.6-2.5C61.8 39 64.6 26.4 59.4 17 53.6 6.8 40.9 6.6 29 11.1 11.4 17.8 5.5 29.9 9.5 41.8c1.8 5.4 4.3 6.8 7 7.3 1.5.3 1.6 2 .3 2.4-6 1.8-12.4-.5-15.5-8.9C-4.2 27.4 8.7 13 29.4 5.1s43.7-7.2 49 6.5c5.4 14.1-6.3 29.6-31.3 39.8-4.7 1.9-9.1 3.4-13.3 4.4z"
        />
        <path
          class="logo-letter"
          d="M63.8 61.1s-1.1 17.8-13.4 19.8c-6 1-5.4-4.5-5.4-4.5s9-.5 12.2-8.6c1.9-4.6-.6-9.1-4.7-9.4-11.5-1-14.8 7.4-16.2 15.7-1.1 6.6 3.6 11.3 11 11.3 17.6 0 19.3-24.3 19.3-24.3h-2.8zm-11.3.2c2 0 3 4.4-.3 8.6-3 3.7-6.8 3.7-6.8 3.7s2.4-12.3 7.1-12.3z"
        />
        <path
          class="logo-letter"
          d="M112.5 76.8c-3.6-1.2-9.7-18.3-15.9-18.3-9.1 0-12.8 21.9-19.2 21.9-5.8 0 1.6-19.5 1.7-19.8.2-.7-.3-2.1-1.8-2.1H63.8v2.8h6.5s-2.5 15.3-2.5 15.8c-.7 4.5 1.4 8.3 7.6 8.3 10 .1 12.7-20.2 18.4-20.2 5.4 0 9.8 20.2 17.7 20.2 3.7 0 10.6-6.8 12.3-8.5.3-.3.4-.5.2-.8-.2-.4-.5-1.1-.9-1.8-.2-.3-.4-.4-.7-.2-1.6.8-7.2 3.6-9.9 2.7z"
        />
        <path
          class="logo-letter"
          d="M92.4 83.5c2.5-2.9 20.5-23.8 24.3-24.9 2-.6 3.7.7 4.5 1.4.4.4.2.7 0 .9-6.5 5.9-23.9 22-26.7 24.6-.2.2-.6.1-.7 0-.4-.4-1.1-1-1.4-1.4-.1-.1-.2-.4 0-.6z"
        />
      </svg>
    </router-link>

    <nav>
      <ul class="plain">
        <li v-for="item in $options.navItems" :key="item.text">
          <a v-bind="item.attrs">{{ item.text }}</a>
        </li>

        <template v-if="user">
          <li><VAction :to="{ name: 'Dashboard' }">Dashboard</VAction></li>
          <li><VAction :to="{ name: 'Admin' }">Admin</VAction></li>
          <li><VAction @click="logout">Logout</VAction></li>
        </template>
        <li v-else-if="!isProd">
          <VAction :to="{ name: 'Login' }">Login/Register</VAction>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import store from "../store"
const isProd = process.env.NODE_ENV === "production"
export default {
  isProd,
  navItems: [
    {
      text: "Getting Started",
      attrs: {
        href: "https://perxapp.com/getting-started/",
      },
    },
    {
      text: "FAQ",
      attrs: {
        href: "https://perxapp.com/frequently-asked-questions/",
      },
    },
  ],
  computed: {
    user: store.get.user,
  },
  methods: {
    logout: store.actions.logout,
  },
}
</script>

<style>
.app-header {
  max-width: 150px;
}
</style>
